module.exports = __webpack_public_path__ + "static/media/my-profile-active-vetor.3e3acee5.svg";